import cn from 'classnames';
import React, {FunctionComponent} from 'react';
import IconEmptyStar from '../components/icon/IconEmptyStar';
import IconHalfStar from '../components/icon/IconHalfStar';
import IconFullStar from '../components/icon/IconFullStar';

type RatingProps = {
  rating: number
  approved: boolean
}

const Rating: FunctionComponent<RatingProps> = ({rating, approved}) => {
  const fullStars = new Array(Math.floor(rating / 2)).fill(String(1));
  const halfStar = rating % 2 !== 0;
  const emptyStars = new Array(Math.floor((10 - rating) / 2)).fill(String(1));
  const className = approved ? 'text-yellow' : 'text-gray-dark';

  return (
    <span className={className}>
      {fullStars.map(() => <IconFullStar className={cn('ml-1', className)} key={Math.random()}/>)}
      {halfStar && <IconHalfStar className={cn('ml-1', className)}/>}
      {emptyStars.map(() => <IconEmptyStar className={cn('ml-1', className)} key={Math.random()}/>)}
    </span>
  );
};

export default Rating;
